
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireed35"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireed35"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2nLJ0", function(module, exports) {

$parcel$export(module.exports, "provideIntoWindow", function () { return $1bc2bfe99d8ae69c$export$7f4e0cb3d55d3229; });
/**
 * Provide anything into window object
 * @param {string} key - field name
 * @param {any} value - field value
 * @return {value}
 */ function $1bc2bfe99d8ae69c$export$7f4e0cb3d55d3229(key, value) {
    // eslint-disable-next-line
    if (typeof window !== "undefined") // eslint-disable-next-line
    window[key] = value;
    return value;
}

});


var $2nLJ0 = parcelRequire("2nLJ0");
var $fca126e2ff67b879$export$a109795f6da16587 = $fca126e2ff67b879$export$a109795f6da16587 || {};
$fca126e2ff67b879$export$a109795f6da16587.gsapVersion = "3";
$fca126e2ff67b879$export$a109795f6da16587.sport = true;
$fca126e2ff67b879$export$a109795f6da16587.sportVersion = 3;
$fca126e2ff67b879$export$a109795f6da16587.sportId = "rabona";
$fca126e2ff67b879$export$a109795f6da16587.sportFixedTop = 140;
$fca126e2ff67b879$export$a109795f6da16587.useSvgSprite = false;
$fca126e2ff67b879$export$a109795f6da16587.scripts = $fca126e2ff67b879$export$a109795f6da16587.scripts || [];
$fca126e2ff67b879$export$a109795f6da16587.domain = "https://rabona.devv2.space";
$fca126e2ff67b879$export$a109795f6da16587.siteDomain = "https://rabona.com";
$fca126e2ff67b879$export$a109795f6da16587.cdn = "/joxi";
$fca126e2ff67b879$export$a109795f6da16587.mobile = false;
$fca126e2ff67b879$export$a109795f6da16587.apiVersion = "v2";
$fca126e2ff67b879$export$a109795f6da16587.pwa = true;
$fca126e2ff67b879$export$a109795f6da16587.appName = "Rabona";
$fca126e2ff67b879$export$a109795f6da16587.themeColor = "#1E2737";
$fca126e2ff67b879$export$a109795f6da16587.siteName = "rabona";
$fca126e2ff67b879$export$a109795f6da16587.libphonenumber = true;
$fca126e2ff67b879$export$a109795f6da16587.hotjar = {
    customHeatMapEnabled: true
};
$fca126e2ff67b879$export$a109795f6da16587.redirectToNotFound = false;
//- ПЛЕЙСИ ДЛЯ БАНЕРІВ І СЛАЙДЕРІВ
//- в шаблоні вказувати саме об'єкт конфіга.
$fca126e2ff67b879$export$a109795f6da16587.places = {
    banner: {
        login: `'login'`,
        home1: `'sport_main_banner'`,
        home2: `'paynplay_pay'`,
        home3: `'sport_promotion'`,
        home4: `'live_promotion'`,
        home5: `'casino_promotion'`,
        home6: `'collection_main_banner1'`,
        home7: `'homepage_banner_promos'`,
        home8: `'homepage_banner_crab'`,
        casino_main: `'casino_main_banner'`,
        card_guide: `'collection_guide'`,
        season_sport_tournament: `'season_sport_tournament'`,
        home_ao: `'home_page_ao_banner'`,
        easter_main: `'easter_banner'`
    },
    slider: {
        gamehall1: `'game_hall'`
    },
    promo: {
        registration: `'welcome_bonus'`,
        home1: `'sport_main'`,
        home2: `'casino_main'`,
        card_guide: `'collection_guide'`
    },
    icons: {
        footer1: `'footer_pay'`,
        paynplay: `'paynplay_pay'`
    }
};
$fca126e2ff67b879$export$a109795f6da16587.sportBanners = {
    topCenter: {
        iframe: `/sport-banners-slider/`,
        options: {
            pages: [
                "prelive"
            ],
            height: "190px"
        }
    },
    bottomRight: {
        iframe: `${$fca126e2ff67b879$export$a109795f6da16587.cdn}/js/crab/sdk/views/widget-sport.html?build=${Date.now()}`,
        options: {
            height: "486px"
        }
    }
};
$fca126e2ff67b879$export$a109795f6da16587.googleAnalytics = {
    appId: "UA-151907223-1",
    trackAs: "rabona"
};
$fca126e2ff67b879$export$a109795f6da16587.sportCategory = {
    football: "football",
    basketball: "basketball",
    hockey: "hockey"
};
$fca126e2ff67b879$export$a109795f6da16587.symplify = true;
//[ 'football' , 'basketball' , 'hockey' ];
if (typeof window !== "undefined") {
    window.$_REGISTRATION = {};
    window.$_REGISTRATION.promotions = {
        category: "welcome_bonus",
        active: 0
    };
}
$fca126e2ff67b879$export$a109795f6da16587.sentry = {
    enabled: true,
    key: "593b6383a70422b7287ff5db450e90c7",
    id: "151",
    project: "rabona"
};


const $de4b7db162e3a11d$export$9af93bb9e9126a2 = {
    home: {
        page: true,
        name: "app.root.h1.f1.home"
    },
    deposit: {
        page: false,
        name: "cashbox",
        private: true
    },
    withdrawal: {
        page: false,
        name: "cashbox",
        content: {
            cashboxState: {
                tab: "withdrawal"
            }
        },
        private: true
    },
    login: {
        page: false,
        name: "login"
    },
    registration: {
        page: false,
        name: "registration"
    },
    fastRegistration: {
        page: true,
        name: "app.root.h1.f1.paynplay"
    },
    promo: {
        page: true,
        name: "app.root.h1.f1.promo.list"
    },
    promotions: {
        page: true,
        name: "app.root.h1.f1.promo.list"
    },
    promos: {
        page: true,
        name: "app.root.h1.f1.promo.item"
    },
    realGame: {
        page: true,
        name: "app.root.game.real",
        private: true
    },
    demoGame: {
        page: true,
        name: "app.root.game.demo"
    },
    santa_slope: {
        page: true,
        name: "app.root.game.real",
        params: {
            name: "santas-slope"
        }
    },
    tournaments: {
        page: true,
        name: "app.root.h1.f1.tournament.list"
    },
    profile: {
        page: true,
        name: "app.root.h1.f1.account.info",
        private: true
    },
    bonuses: {
        page: true,
        name: "app.root.h1.f1.account.bonuses",
        private: true
    },
    paynplay: {
        page: true,
        name: "app.root.h1.f1.paynplay"
    },
    gameHall: {
        page: true,
        name: "app.root.h1.f1.casino.hall"
    },
    collection: {
        page: true,
        name: "app.root.h1.f1.collection.list"
    },
    bet: {
        page: true,
        name: "app.root.h1.f1.sportpage.prelive"
    },
    sport: {
        page: true,
        name: "app.root.h1.f1.sportpage.prelive"
    },
    live: {
        page: true,
        name: "app.root.h1.f1.casino.hall",
        params: {
            collection: "live-casino"
        }
    },
    games: {
        page: true,
        name: "app.root.h1.f1.casino.hall"
    },
    responsibleGaming: {
        page: true,
        name: "app.root.h1.f1.account.responsible-gaming",
        private: true
    },
    balanceHistory: {
        page: true,
        name: "app.root.h1.f1.account.history",
        private: true
    },
    notFound: {
        page: true,
        name: "app.root.h1.f1.404"
    },
    missedData: {
        page: true,
        name: "app.root.missedData"
    },
    terms: {
        page: true,
        name: "app.root.h1.f1.info.terms"
    },
    bigbassbonanza: {
        page: true,
        name: "app.root.game.real",
        params: {
            name: "big-bass-bonanza"
        },
        private: true
    },
    bigbassbonanzademo: {
        page: true,
        name: "app.root.game.demo",
        params: {
            name: "big-bass-bonanza"
        }
    },
    // promo steps aliases
    football: {
        page: true,
        name: "app.root.h1.f1.sportpage.prelive",
        params: {
            sportids: "66"
        }
    },
    tenis: {
        page: true,
        name: "app.root.h1.f1.sportpage.prelive",
        params: {
            sportids: "68"
        }
    },
    soccer: {
        page: true,
        name: "app.root.h1.f1.sportpage.prelive",
        params: {
            sportids: "66"
        }
    },
    tennis: {
        page: true,
        name: "app.root.h1.f1.sportpage.prelive",
        params: {
            sportids: "68"
        }
    },
    tabletenis: {
        page: true,
        name: "app.root.h1.f1.sportpage.prelive",
        params: {
            sportids: "77"
        }
    },
    basketball: {
        page: true,
        name: "app.root.h1.f1.sportpage.prelive",
        params: {
            sportids: "67"
        }
    },
    icehockey: {
        page: true,
        name: "app.root.h1.f1.sportpage.prelive",
        params: {
            sportids: "70"
        }
    },
    esports: {
        page: true,
        name: "app.root.h1.f1.sportpage.prelive",
        params: {
            sportids: "145"
        }
    },
    formula1: {
        page: true,
        name: "app.root.h1.f1.sportpage.prelive",
        params: {
            sportids: "103"
        }
    },
    mma: {
        page: true,
        name: "app.root.h1.f1.sportpage.prelive",
        params: {
            sportids: "84"
        }
    },
    cricket: {
        page: true,
        name: "app.root.h1.f1.sportpage.prelive",
        params: {
            sportids: "149"
        }
    },
    americanfootball: {
        page: true,
        name: "app.root.h1.f1.sportpage.prelive",
        params: {
            sportids: "75"
        }
    },
    baseball: {
        page: true,
        name: "app.root.h1.f1.sportpage.prelive",
        params: {
            sportids: "76"
        }
    },
    euro2024: {
        page: true,
        name: "app.root.h1.f1.sportpage.prelive",
        params: {
            champids: "3031"
        }
    },
    livechat: {
        page: false,
        name: "chat"
    },
    chat: {
        page: false,
        name: "chat"
    },
    dropwins: {
        page: true,
        name: "app.root.h1.f1.tournament.page",
        params: {
            name: "drops-wins"
        }
    },
    // ================= horse racing aliases
    leftlink1: {
        page: true,
        name: "app.root.h1.f1.cup"
    },
    leftlink2: {
        page: true,
        name: "app.root.h1.f1.collection.list"
    },
    leftlink3: {
        page: true,
        name: "app.root.h1.f1.account.achievement"
    },
    leftlink4: {
        page: true,
        name: "app.root.h1.f1.promo.list"
    },
    rightlink1: {
        page: true,
        name: "app.root.h1.f1.casino.hall",
        params: {
            collection: "live-casino"
        }
    },
    rightlink2: {
        page: true,
        name: "app.root.h1.f1.casino.s1.collection",
        params: {
            category: "slots"
        }
    },
    rightlink3: {
        page: true,
        name: "app.root.h1.f1.casino.s1.collection",
        params: {
            category: "popular"
        }
    },
    rightlink4: {
        page: true,
        name: "app.root.h1.f1.casino.s1.collection",
        params: {
            category: "top"
        }
    },
    // <MACHINES>
    gameProvider: {
        page: true,
        name: "app.root.h1.f1.casino.s1.provider"
    },
    oktoberfest: {
        page: true,
        name: "app.root.h1.claw_games.gamepage",
        params: {
            name: "oktoberfest"
        }
    },
    // tysonPromo: {
    //   page: true,
    //   name: 'app.root.h1.f1.tyson_ambassador',
    // },
    cup: {
        page: true,
        name: "app.root.h1.f1.cup"
    },
    cash_crab: {
        page: true,
        name: "app.root.h1.claw_games.gamepage",
        params: {
            name: "cash_crab"
        }
    },
    bonus_crab: {
        page: true,
        name: "app.root.h1.claw_games.gamepage",
        params: {
            name: "cash-crab"
        }
    },
    claw: {
        page: true,
        name: "app.root.h1.claw_games.gamepage"
    },
    // ================= horse racing aliases
    HoRacing: {
        page: true,
        name: "app.root.h1.f1.horse_racing.horse_racing"
    },
    HaRacing: {
        page: true,
        name: "app.root.h1.f1.horse_racing.harness"
    },
    GreyRacing: {
        page: true,
        name: "app.root.h1.f1.horse_racing.greyhound"
    },
    NextToJump: {
        page: true,
        name: "app.root.h1.f1.horse_racing.next-to-jump"
    },
    evolution: {
        page: true,
        name: "app.root.h1.f1.casino.s1.provider",
        params: {
            name: "evolution"
        }
    },
    pragmatic: {
        page: true,
        name: "app.root.h1.f1.casino.s1.provider",
        params: {
            name: "pragmatic"
        }
    },
    playngo: {
        page: true,
        name: "app.root.h1.f1.casino.s1.provider",
        params: {
            name: "playngo"
        }
    },
    threeoaks: {
        page: true,
        name: "app.root.h1.f1.casino.s1.provider",
        params: {
            name: "threeoaks"
        }
    },
    spinomenal: {
        page: true,
        name: "app.root.h1.f1.casino.s1.provider",
        params: {
            name: "spinomenal"
        }
    },
    ela: {
        page: true,
        name: "app.root.h1.f1.casino.s1.provider",
        params: {
            name: "ela"
        }
    },
    relax: {
        page: true,
        name: "app.root.h1.f1.casino.s1.provider",
        params: {
            name: "relax"
        }
    },
    skywind: {
        page: true,
        name: "app.root.h1.f1.casino.s1.provider",
        params: {
            name: "skywind"
        }
    },
    netent: {
        page: true,
        name: "app.root.h1.f1.casino.s1.provider",
        params: {
            name: "netent"
        }
    },
    pushgaming: {
        page: true,
        name: "app.root.h1.f1.casino.s1.provider",
        params: {
            name: "pushgaming"
        }
    },
    playtech: {
        page: true,
        name: "app.root.h1.f1.casino.s1.provider",
        params: {
            name: "playtech"
        }
    },
    quickspin: {
        page: true,
        name: "app.root.h1.f1.casino.s1.provider",
        params: {
            name: "quickspin"
        }
    },
    redtiger: {
        page: true,
        name: "app.root.h1.f1.casino.s1.provider",
        params: {
            name: "redtiger"
        }
    },
    promo_astropay: {
        page: true,
        name: "app.root.h1.f1.promo.item",
        params: {
            name: "40-extra-com-astropay"
        }
    },
    christmasPromotion: {
        page: true,
        name: "app.root.h1.f1.promo.item",
        params: {
            name: "million-frostival-spins"
        }
    },
    christmasPromotionRaffle: {
        page: true,
        name: "app.root.h1.f1.promo.item",
        params: {
            name: "frostival-prizes"
        }
    },
    "easter-giveaway": {
        page: true,
        name: "app.root.h1.f1.promo.item",
        params: {
            name: "easter-giveaway"
        }
    },
    summer: {
        page: true,
        name: "app.root.summer",
        private: true
    },
    summerGame: {
        page: true,
        name: "app.root.summer-game"
    },
    australianOpen: {
        page: true,
        name: "app.root.h1.f1.sportpage.prelive",
        params: {
            sportids: "68"
        }
    },
    footballlive: {
        page: true,
        name: "app.root.h1.f1.sportpage.prelive",
        params: {
            sportids: "66"
        }
    },
    tennislive: {
        page: true,
        name: "app.root.h1.f1.sportpage.prelive",
        params: {
            sportids: "68"
        }
    },
    basketballlive: {
        page: true,
        name: "app.root.h1.f1.sportpage.prelive",
        params: {
            sportids: "67"
        }
    },
    icehockeylive: {
        page: true,
        name: "app.root.h1.f1.sportpage.prelive",
        params: {
            sportids: "70"
        }
    },
    tabletennislive: {
        page: true,
        name: "app.root.h1.f1.sportpage.prelive",
        params: {
            sportids: "77"
        }
    },
    virtual: {
        page: true,
        name: "app.root.h1.f1.sportpage.virtual"
    },
    footballvr: {
        page: true,
        name: "app.root.h1.f1.sportpage.virtual",
        params: {
            sportids: "kiron_football"
        }
    },
    ebasketball: {
        page: true,
        name: "app.root.h1.f1.sportpage.live",
        params: {
            sportids: "147"
        }
    },
    efootball: {
        page: true,
        name: "app.root.h1.f1.sportpage.live",
        params: {
            sportids: "146"
        }
    },
    handball: {
        page: true,
        name: "app.root.h1.f1.sportpage.live",
        params: {
            sportids: "73"
        }
    },
    tennisvr: {
        page: true,
        name: "app.root.h1.f1.sportpage.virtual",
        params: {
            sportids: "vti"
        }
    },
    esport: {
        page: true,
        name: "app.root.h1.f1.sportpage.prelive",
        params: {
            sportids: "145"
        }
    },
    edogracing: {
        page: true,
        name: "app.root.h1.f1.sportpage.virtual",
        params: {
            sportids: "kiron_dogs"
        }
    },
    ehorseracing: {
        page: true,
        name: "app.root.h1.f1.sportpage.virtual",
        params: {
            sportids: "kiron_horses"
        }
    },
    horseracing: {
        page: true,
        name: "app.root.h1.f1.horse_racing.horse_racing",
        params: {
            category: "horseRacing"
        }
    },
    emotoracing: {
        page: true,
        name: "app.root.h1.f1.sportpage.virtual",
        params: {
            sportids: "kiron_motor_racing"
        }
    }
};


const $7231a392dc32015a$export$5375cda95f0b0eb4 = [
    ///////////////////
    // layer routes
    ///////////////////
    {
        name: "app.root",
        abstract: true,
        template: "<linda-app linda-zendesk ></linda-app>"
    },
    // header
    {
        name: "app.root.h1",
        abstract: true,
        template: '<linda-view-layer-one class="has-header linda-layer"></linda-view-layer-one>'
    },
    // header + footer
    {
        name: "app.root.h1.f1",
        abstract: true,
        template: '<linda-view-layer-two class="linda-layer"></linda-view-layer-two>'
    },
    ////////////////////
    // empty template
    ////////////////////
    {
        name: "app.root.paymentcb",
        url: "/payment/:act?order_id&identifier",
        template: "<linda-payment-callback></linda-payment-callback>"
    },
    {
        name: "app.root.withdraw-paymentcb-success",
        url: "/withdraw-payment/success",
        template: "<linda-withdrawal-payment-callback></linda-withdrawal-payment-callback>",
        params: {
            status: "success"
        }
    },
    {
        name: "app.root.withdraw-paymentcb-fail",
        url: "/withdraw-payment/fail",
        template: "<linda-withdrawal-payment-callback></linda-withdrawal-payment-callback>",
        params: {
            status: "fail"
        }
    },
    // For redirecting to homepage after clicking home button in game iframe
    {
        name: "app.root.callback",
        url: "/callback/:name",
        template: "<linda-callback-page/>"
    },
    //////////////////////////
    // header + footer
    /////////////////////////
    {
        name: "app.root.h1.f1.home",
        url: "/",
        template: "<linda-homepage scroll-to-top></linda-homepage>"
    },
    {
        name: "app.root.summer",
        url: "/seasons/summer",
        private: true,
        template: '<summer-promo-wrapper scroll-to-top="" ></summer-promo-wrapper>'
    },
    {
        name: "app.root.summer-game",
        url: "/seasons-summer",
        private: true,
        template: `<summer-promo-page scroll-to-top=""></summer-promo-page>`
    },
    {
        name: "app.root.h1.f1.404",
        url: "/404",
        template: '<not-found class="full-screen"></not-found>'
    },
    //////////////////////////
    // Missed data
    /////////////////////////
    {
        name: "app.root.missedData",
        url: "/missed-data",
        template: "<linda-missed-data-form/>"
    },
    //////////////////////////
    // Paynplay
    /////////////////////////
    {
        name: "app.root.h1.f1.paynplay",
        url: "/fast-deposit",
        template: '<linda-zimpler-paynplay-page scroll-to-top class="full-screen"></linda-zimpler-paynplay-page>'
    },
    //////////////////////////
    // Info pages
    /////////////////////////
    {
        name: "app.root.h1.f1.info",
        abstract: true,
        template: "<linda-view-layer-six scroll-to-top></linda-view-layer-six>"
    },
    {
        name: "app.root.h1.f1.info.sitemap",
        url: "/sitemap",
        template: "<linda-sitemap scroll-to-top></linda-sitemap>",
        params: {
            name: "sitemap"
        }
    },
    {
        name: "app.root.h1.f1.info.privacy-policy",
        url: "/privacy-policy",
        template: "<linda-info-page scroll-to-top></linda-info-page>",
        params: {
            pageName: "info",
            name: "privacy-policy"
        }
    },
    {
        name: "app.root.h1.f1.info.about",
        url: "/about-us",
        template: "<linda-info-page scroll-to-top></linda-info-page>",
        params: {
            pageName: "info",
            name: "about"
        }
    },
    {
        name: "app.root.h1.f1.info.contact",
        url: "/contact-us",
        template: "<linda-info-page scroll-to-top></linda-info-page>",
        params: {
            pageName: "info",
            name: "contact-us"
        }
    },
    {
        name: "app.root.h1.f1.info.responsible-gaming",
        url: "/responsible-gaming",
        template: "<linda-info-page scroll-to-top></linda-info-page>",
        params: {
            pageName: "info",
            name: "responsible-gaming"
        }
    },
    {
        name: "app.root.h1.f1.info.terms",
        url: "/rules",
        template: "<linda-info-page scroll-to-top></linda-info-page>",
        params: {
            pageName: "info",
            name: "rules"
        }
    },
    {
        name: "app.root.h1.f1.info.faq",
        url: "/faq",
        template: "<linda-info-page scroll-to-top></linda-info-page>",
        params: {
            pageName: "info",
            name: "faq"
        }
    },
    {
        name: "app.root.h1.f1.info.cookies-policy",
        url: "/cookies-policy",
        template: "<linda-info-page scroll-to-top></linda-info-page>",
        params: {
            pageName: "info",
            name: "cookies-policy"
        }
    },
    /////////////////////////////////////
    // Collections
    /////////////////////////////////////
    {
        name: "app.root.h1.f1.collection",
        abstract: true,
        //private:true,
        template: "<ui-view></ui-view>"
    },
    {
        name: "app.root.h1.f1.collection.list",
        url: "/collections",
        template: '<batman-sport-team-list1  scroll-to-top="" ></batman-sport-team-list1>'
    },
    {
        name: "app.root.h1.f1.collection.item",
        private: true,
        url: "/collections/:name",
        template: '<linda-sport-team-page  scroll-to-top="" ></linda-sport-team-page>'
    },
    {
        name: "app.root.h1.f1.collection.guide",
        url: "/collections-terms",
        template: '<linda-view-layer-five  scroll-to-top="" ></linda-view-layer-five>'
    },
    /////////////////////////////////////
    // VIP
    /////////////////////////////////////
    {
        name: "app.root.h1.f1.vip",
        url: "/vip",
        template: '<linda-vip class="full-screen" scroll-to-top="" ></linda-vip>'
    },
    /////////////////////////////////////
    // CUP
    /////////////////////////////////////
    {
        name: "app.root.h1.f1.cup",
        private: true,
        url: "/champions-cup",
        template: '<linda-cup-page class="full-screen" scroll-to-top="" ></linda-cup-page>'
    },
    /////////////////////////////////////
    // Holidays promos
    /////////////////////////////////////
    // {
    //   name: 'app.root.h1.f1.seasons',
    //   url: '/seasons/:name',
    //   template: `<linda-promo-wrapper class="holiday-promo-wrapper" scroll-to-top=""></linda-promo-wrapper>`,
    // },
    // {
    //   name: 'app.root.h1.f1.seasons',
    //   url: '/seasons/:name',
    //   template: '<easter-promo scroll-to-top="" ></easter-promo>',
    // },
    /////////////////////////////////////
    // Sport
    /////////////////////////////////////
    {
        name: "app.root.h1.f1.sportpage",
        abstract: true,
        template: "<linda-sport-page></linda-sport-page>"
    },
    {
        name: "app.root.h1.f1.sportpage.prelive",
        url: "/sport?sportids&catids&champids&tabs&eventid&betslipoddids",
        template: "",
        params: {
            page: "prelive",
            isHashMode: false
        }
    },
    {
        name: "app.root.h1.f1.sportpage.live",
        url: "/live?sportids&catids&champids&tabs&eventid&betslipoddids",
        template: "",
        params: {
            page: "live",
            isHashMode: false
        }
    },
    {
        name: "app.root.h1.f1.sportpage.virtual",
        url: "/virtual?sportids&catids&champids&tabs&eventid&betslipoddids",
        template: "",
        params: {
            page: "vflm",
            isHashMode: false
        }
    },
    {
        name: "app.root.h1.f1.horse_racing",
        abstract: true,
        template: '<linda-view-layer-seven scroll-to-top=""></>linda-view-layer-seven'
    },
    {
        name: "app.root.h1.f1.horse_racing.horse_racing",
        url: "/horse-racing",
        params: {
            category: "horseRacing"
        }
    },
    {
        name: "app.root.h1.f1.horse_racing.harness",
        url: "/harness",
        params: {
            category: "harness"
        }
    },
    {
        name: "app.root.h1.f1.horse_racing.greyhound",
        url: "/greyhound",
        params: {
            category: "greyhound"
        }
    },
    {
        name: "app.root.h1.f1.horse_racing.next-to-jump",
        url: "/next-to-jump",
        params: {
            category: "nextToJump"
        }
    },
    /////////////////////////////////////
    // Promotions
    /////////////////////////////////////
    {
        name: "app.root.h1.f1.promo",
        abstract: true,
        template: '<ui-view class="linda-view"></ui-view>'
    },
    {
        name: "app.root.h1.f1.promo.list",
        url: "/promotions",
        template: '<linda-promos scroll-to-top=""></linda-promos>'
    },
    {
        name: "app.root.h1.f1.promo.item",
        url: "/promotions/:name",
        template: '<linda-promo-page scroll-to-top="" promo="$resolve.promo"></linda-promo-page>',
        resolve: {
            promo: [
                "promoItemResolver",
                function(promoItemResolver) {
                    return promoItemResolver.resolve();
                }
            ]
        }
    },
    /////////////////////////////////////
    // Tournaments
    /////////////////////////////////////
    {
        name: "app.root.h1.f1.tournament",
        abstract: true,
        template: '<ui-view class="linda-view" scroll-to-top></ui-view>'
    },
    {
        name: "app.root.h1.f1.tournament.list",
        url: "/tournaments",
        template: '<batman-tournament-list1 players="true" competitors="5"></batman-tournament-list1>'
    },
    {
        name: "app.root.h1.f1.tournament.page",
        url: "/tournaments/:name",
        template: '<linda-tournament-page tournament="$resolve.tournament"></linda-tournament-page>',
        params: {
            hasLeagues: true
        },
        resolve: {
            tournament: [
                "tournamentItemResolver",
                function(tournamentItemResolver) {
                    return tournamentItemResolver.resolve();
                }
            ]
        }
    },
    // THE MASTERS is hidden while the EURO 2024 is active
    // {
    //   name: 'app.root.h1.f1.sporttournament',
    //   url: '/sport-tournament',
    //   template: '<batman-view-layer2 scroll-to-top></batman-view-layer2>',
    //   params: {
    //     name: 'the-masters-rabona',
    //     hasLeagues: true,
    //   },
    // },
    /////////////////////////////////////
    // GAME HALL
    /////////////////////////////////////
    {
        name: "app.root.h1.f1.casino",
        abstract: true,
        template: "<linda-view-layer-three></linda-view-layer-three>"
    },
    {
        name: "app.root.h1.f1.casino.s1.last-played",
        url: "/games/continue-playing",
        private: true,
        template: "<batman-recently-played-list3 scroll-to-top ></batman-recently-played-list3>",
        params: {
            collection: "games"
        }
    },
    {
        name: "app.root.h1.f1.casino.s1",
        abstract: true,
        template: "<linda-view-layer-four></linda-view-layer-four>"
    },
    {
        name: "app.root.h1.f1.casino.s1.provider",
        url: "/casino-providers/:name",
        template: "<batman-game-hall2 scroll-to-top></batman-game-hall2>",
        params: {
            providers: "provider"
        }
    },
    {
        name: "app.root.h1.f1.casino.s1.favourites",
        url: "/favourites",
        template: "<batman-game-box-favourites2 scroll-to-top></batman-game-box-favourites2>",
        params: {
            collection: "games"
        }
    },
    /////////////////////////////////////
    //header + footer + sidebar profile
    //////////////////////////////////////
    {
        name: "app.root.h1.f1.account",
        abstract: true,
        private: true,
        template: '<linda-profile-page class="profile-page"></linda-profile-page>'
    },
    {
        name: "app.root.h1.f1.account.info",
        url: "/account",
        template: '<linda-profile-settings scroll-to-top=""></linda-profile-settings>'
    },
    {
        name: "app.root.h1.f1.account.bonuses",
        url: "/account/my-bonuses",
        template: '<linda-profile-bonus-list scroll-to-top=""></linda-profile-bonus-list>'
    },
    {
        name: "app.root.h1.f1.account.history",
        url: "/account/balance-history",
        template: '<linda-cashbox-balance-information scroll-to-top=""></linda-cashbox-balance-information>'
    },
    {
        name: "app.root.h1.f1.account.achievement",
        url: "/account/weekly-achievement",
        template: '<linda-achievements-page scroll-to-top=""></linda-achievements-page>'
    },
    {
        name: "app.root.h1.f1.account.responsible-gaming",
        url: "/account/responsible-gaming",
        template: '<linda-selfcontrol-wrapper scroll-to-top=""></linda-selfcontrol-wrapper>'
    },
    //Identify verification profile page
    {
        name: "app.root.h1.f1.account.verification",
        url: "/account/verification",
        template: "<dvs-page scroll-to-top></dvs-page>"
    },
    {
        name: "app.root.h1.f1.account.mybets",
        url: "/account/mybets",
        template: '<batman-ui-wrapper1 scroll-to-top=""></batman-ui-wrapper1>',
        params: {
            page: "mybets",
            isHashMode: false
        }
    },
    ////////////////////
    // header 2  + footer 2
    //////////////////
    {
        name: "app.root.game",
        abstract: true,
        template: '<linda-game-page class="game-page-wrap"></linda-game-page>',
        gamePage: true
    },
    // <MACHINES> ...
    {
        name: "app.root.h1.claw_games",
        abstract: true,
        private: true,
        template: "<ui-view></ui-view>"
    },
    {
        name: "app.root.h1.claw_games.gamepage",
        url: "/machine/:name",
        template: "<batman-view-layer1 />"
    },
    //- </MACHINES>
    /*
  {
    name: 'app.root.h1.bonus-crab',
    url: '/play/cash-crab',
    template: '<batman-view-layer1 />',
    private: true,
  },
  {
    name: 'app.root.h1.cash-crab',
    url: '/play/cash_crab',
    template: '<batman-view-layer2 />',
    private: true,
  },

   */ {
        name: "app.root.game.real",
        url: "/play/:name",
        template: "",
        private: true,
        params: {
            mode: "real"
        }
    },
    {
        name: "app.root.game.demo",
        url: "/game/:name",
        template: '<linda-demo-game-footer  game="game"></linda-demo-game-footer>',
        params: {
            mode: "demo"
        }
    },
    ////////////////////
    // All payments page
    //////////////////
    {
        name: "app.root.h1.f1.payments-list",
        url: "/payments-list",
        template: '<batman-banking-page1 scroll-to-top=""></batman-banking-page1>'
    },
    {
        name: "app.root.h1.f1.casino.s1.collection",
        url: "/:collection/:category",
        template: "<batman-game-hall1 scroll-to-top></batman-game-hall1>",
        params: {
            collection: "games",
            category: "top"
        },
        onEnter: [
            "casinoResolver",
            function(casinoResolver) {
                casinoResolver.collection();
            }
        ]
    },
    {
        name: "app.root.h1.f1.casino.hall",
        url: "/:collection",
        template: "<linda-casino-section scroll-to-top ></linda-casino-section>",
        params: {
            collection: "games"
        },
        onEnter: [
            "casinoResolver",
            function(casinoResolver) {
                casinoResolver.collection();
            }
        ]
    }
];


const $b6945145e5a5455c$export$df0ef5408bae6046 = undefined;


const $d08954e785180626$export$5ee78da69427eb2a = Object.assign({}, (0, $fca126e2ff67b879$export$a109795f6da16587), {
    aliases: $de4b7db162e3a11d$export$9af93bb9e9126a2
}, {
    router: $7231a392dc32015a$export$5375cda95f0b0eb4
}, {
    slider: $b6945145e5a5455c$export$df0ef5408bae6046
});


//- All property styles you can check on this page:
//- https://sb2wsdk-altenar2-stage.biahosted.com/docs/?path=/docs/widgets-common-tokens--docs
//- On this page you can try constructor styles:
//- https://sb2wsdk-altenar2-stage.biahosted.com/docs/?path=/docs/widgets-wlivenow--docs
const $8db7b28d8ea342cc$export$ca0c1c7c8663689b = {};
let $8db7b28d8ea342cc$var$widget = {
    OddBox: {
        variant: 0,
        spacing: 4,
        borderRadius: 2,
        borderWidth: 1,
        borderColor: "rgba(255, 255, 255, 0.1)",
        background: "#394557",
        paddingVertical: 10,
        paddingHorizontal: 12,
        oddFont: [
            "Roboto",
            16,
            "normal",
            400,
            "normal"
        ],
        labelFont: [
            "Roboto",
            16,
            "normal",
            400,
            "normal"
        ],
        oddColor: "#ffffff",
        labelColor: "rgba(255, 255, 255, 0.6)",
        arrowUp: [
            24,
            24,
            "#4caf50"
        ],
        arrowDown: [
            24,
            24,
            "#f44336"
        ]
    },
    OddBoxSelected: {
        borderColor: "#fff",
        background: "#05207B",
        oddColor: "#FFFFFF",
        labelColor: "#FFFFFF"
    },
    MarketBox: {
        width: "100%",
        spacing: 4
    },
    EventBox: {
        borderWidth: 1,
        borderColor: "#E9EBF7",
        borderStyle: "solid",
        borderRadius: 0,
        background: "#FFFFFF",
        paddingVertical: 12,
        paddingHorizontal: 12,
        liveTimeFont: [
            "Roboto",
            14,
            "normal",
            500,
            "21px"
        ],
        dateTimeFont: [
            "Roboto",
            12,
            "normal",
            600,
            "20px"
        ],
        categoryChampionshipFont: [
            "Roboto",
            12,
            "normal",
            600,
            "20px"
        ],
        competitorFont: [
            "Roboto",
            14,
            "normal",
            700,
            "21px"
        ],
        scoreFont: [
            "Roboto",
            14,
            "normal",
            700,
            "21px"
        ],
        liveTimeColor: "#65697B",
        dateTimeColor: "rgba(0, 0, 0, 0.87)",
        categoryChampionshipColor: "rgba(0, 0, 0, 0.54)",
        competitorColor: "rgba(0, 0, 0, 0.87)",
        scoreColor: "rgba(0, 0, 0, 0.87)"
    },
    SportTab: {
        borderWidth: 0,
        borderColor: "unset",
        borderStyle: "none",
        borderRadius: 0,
        font: [
            "Roboto Condensed",
            16,
            "normal",
            700,
            "14px"
        ],
        background: "#fff",
        color: "#05207B",
        textTransform: "capitalize",
        paddingHorizontal: 12,
        paddingVertical: 10,
        borderRadius: 0,
        spacing: 16,
        textTransform: "uppercase"
    },
    SportTabSelected: {
        font: [
            "Roboto",
            16,
            "normal",
            700,
            "14px"
        ],
        indicatorColor: "#fff",
        borderColor: "#fff",
        color: "#fff",
        background: "#05207B",
        textTransform: "uppercase"
    },
    TabbedTopSportEvents: {
        borderWidth: 1,
        borderColor: "#E9EBF7",
        borderStyle: "solid",
        borderRadius: 0,
        paddingHorizontal: 20,
        paddingVertical: 20,
        background: "#fff",
        titleColor: "#05207B",
        titleFont: [
            "Roboto",
            18,
            "italic",
            900,
            "40px"
        ],
        titleTextTransform: "uppercase"
    },
    EventList: {
        variant: 1,
        rowSpacing: 6,
        columnSpacing: 16
    },
    LiveIndicator: {
        variant: 0,
        borderWidth: 0,
        borderColor: "unset",
        borderStyle: "none",
        font: [
            "Roboto",
            12,
            "normal",
            700,
            "21px"
        ],
        textTransform: "uppercase",
        background: "#CC0034",
        color: "#fff",
        borderRadius: 0,
        paddingHorizontal: 3,
        paddingVertical: 1,
        clipPath: "unset"
    }
};
let $8db7b28d8ea342cc$var$streaming = {
    LiveStreaming: {
        borderWidth: 0,
        borderColor: "#2A394E",
        background: "#273242",
        borderRadius: 2,
        paddingVertical: 8,
        paddingHorizontal: 8
    },
    LiveStreamingHeader: {
        background: "#273242",
        paddingVertical: 4,
        paddingHorizontal: 20,
        font: [
            "Roboto",
            0,
            "normal",
            500,
            "0px"
        ]
    },
    LiveStreamingTabs: {
        background: "transparent",
        paddingHorizontal: 8
    },
    LiveStreamingTab: {
        background: "transparent",
        color: "#ffffff",
        paddingVertical: 6,
        paddingHorizontal: 6,
        borderWidth: 1,
        borderColor: "transparent",
        iconColor: "#ffffff",
        iconBackground: "transparent"
    },
    LiveStreamingTabSelected: {
        background: "#162334",
        borderWidth: 1,
        borderColor: "#2A394E",
        color: "#ffffff"
    },
    OddBox: {
        variant: 0,
        spacing: 4,
        borderRadius: 2,
        borderWidth: 1,
        borderColor: "rgba(255, 255, 255, 0.1)",
        background: "#182537",
        paddingVertical: 8,
        paddingHorizontal: 12,
        oddFont: [
            "Roboto",
            15,
            "normal",
            400,
            "normal"
        ],
        labelFont: [
            "Roboto",
            15,
            "normal",
            400,
            "normal"
        ],
        oddColor: "#ffffff",
        labelColor: "rgba(255, 255, 255, 0.6)",
        arrowUp: [
            24,
            24,
            "#4caf50"
        ],
        arrowDown: [
            24,
            24,
            "#f44336"
        ]
    },
    OddBoxSelected: {
        borderColor: "rgba(255, 255, 255, 0.10)",
        background: "#ECFD00",
        oddColor: "#0B1222",
        labelColor: "rgba(11, 18, 34, 0.6)"
    },
    LiveStreamingEvent: {
        background: "#273242",
        borderRadius: 2,
        borderWidth: 1,
        borderColor: "#394557",
        paddingVertical: 6,
        paddingHorizontal: 8,
        liveTimeFont: [
            "Roboto Condensed",
            12,
            "normal",
            700,
            "normal"
        ],
        liveTimeColor: "#FFFFFF",
        competitorFont: [
            "Roboto Condensed",
            14,
            "normal",
            400,
            "normal"
        ],
        competitorColor: "#A5AFC0",
        scoreFont: [
            "Roboto Condensed",
            12,
            "normal",
            400,
            "normal"
        ],
        scoreColor: "#A5AFC0"
    },
    LiveStreamingEventSelected: {
        background: "#182537",
        liveTimeColor: "#ECFD00",
        competitorColor: "#EFF5FD",
        scoreColor: "#FFFFFF",
        borderColor: "#394557"
    }
};
let $8db7b28d8ea342cc$var$carousel = {
    OddBox: {
        variant: 0,
        spacing: 4,
        borderRadius: 2,
        borderWidth: 1,
        borderColor: "rgba(255, 255, 255, 0.1)",
        background: "#394557",
        paddingVertical: 10,
        paddingHorizontal: 12,
        oddFont: [
            "Roboto",
            16,
            "normal",
            400,
            "normal"
        ],
        labelFont: [
            "Roboto",
            16,
            "normal",
            400,
            "normal"
        ],
        oddColor: "#ffffff",
        labelColor: "rgba(255, 255, 255, 0.6)",
        arrowUp: [
            24,
            24,
            "#4caf50"
        ],
        arrowDown: [
            24,
            24,
            "#f44336"
        ]
    },
    OddBoxSelected: {
        borderColor: "rgba(255, 255, 255, 0.10)",
        background: "#ECFD00",
        oddColor: "#0B1222",
        labelColor: "rgba(11, 18, 34, 0.6)"
    },
    BannerEventBox: {
        variant: 0,
        width: 320,
        borderWidth: 1,
        borderColor: "#2A394E",
        borderRadius: 2,
        background: "#273242",
        paddingVertical: 20,
        paddingHorizontal: 20,
        timeFont: [
            "Roboto",
            14,
            "normal",
            700,
            "16px"
        ],
        dateFont: [
            "Roboto",
            14,
            "normal",
            400,
            "16px"
        ],
        championshipFont: [
            "Roboto",
            16,
            "normal",
            400,
            "18px"
        ],
        competitorFont: [
            "Roboto",
            16,
            "normal",
            400,
            "18px"
        ],
        messageBodyFont: [
            "Roboto",
            16,
            "normal",
            500,
            "18px"
        ],
        messageHeaderFont: [
            "Roboto",
            16,
            "normal",
            500,
            "18px"
        ],
        timeColor: "#FFFFFF",
        dateColor: "rgba(255, 255, 255, 0.6)",
        championshipColor: "rgba(255, 255, 255, 0.6)",
        competitorColor: "#FFFFFF",
        messageHeaderColor: "#FFFFFF",
        messageBodyColor: "#FFFFFF",
        dividerColor: "rgba(0, 0, 0, 0.12)",
        dividerWidth: 1,
        dividerHeight: "85%",
        scoreColor: "rgba(255, 255, 255)",
        liveTimeColor: "rgba(255, 255, 255)"
    },
    MarketBox: {
        font: [
            "Roboto",
            14,
            "normal",
            700,
            "16px"
        ],
        color: "#ffffff",
        spacing: 4
    },
    CompetitorLogo: {
        height: 64,
        width: 64,
        background: "transparent",
        borderRadius: "0",
        borderColor: "transparent",
        borderWidth: 0,
        offset: -8,
        placeholderColor: "rgba(77, 77, 77, 0.2)"
    },
    EventsCarousel: {
        borderWidth: 0,
        borderColor: "unset",
        borderRadius: 0,
        width: "unset",
        paddingHorizontal: 0,
        paddingVertical: 0,
        spacing: 12
    },
    EventsCarouselControls: {
        borderWidth: 1,
        borderColor: "#2A394E",
        borderRadius: 2,
        dotBackground: "rgba(255, 255, 255, 0.87)",
        selectedDotBackground: "#273242",
        background: "rgb(57, 69, 87)",
        color: "rgba(255, 255, 255, 0.87)",
        height: 201,
        width: 32
    },
    EventsCarouselControlsHovered: {
        background: "#576477",
        color: "#ffffff"
    },
    LiveIndicator: {
        variant: 0,
        borderWidth: 0,
        borderColor: "unset",
        borderStyle: "none",
        font: [
            "Roboto",
            12,
            "normal",
            700,
            "21px"
        ],
        textTransform: "uppercase",
        background: "#CC0034",
        color: "#fff",
        borderRadius: 0,
        paddingHorizontal: 3,
        paddingVertical: 1,
        clipPath: "unset"
    }
};
$8db7b28d8ea342cc$export$ca0c1c7c8663689b.widget = {
    tokens: {
        liveNow: $8db7b28d8ea342cc$var$widget,
        highlights: $8db7b28d8ea342cc$var$widget
    },
    carousel: $8db7b28d8ea342cc$var$carousel,
    streaming: $8db7b28d8ea342cc$var$streaming
};


const $9af22ef03b0ed505$var$pgwUrl = "https://app.payment-gateway.io";
const $9af22ef03b0ed505$var$productionConfig = {};
(0, $2nLJ0.provideIntoWindow)("$_ALTENARCONFIG", (0, $8db7b28d8ea342cc$export$ca0c1c7c8663689b));
const $9af22ef03b0ed505$export$5e143010dea16c85 = (0, $2nLJ0.provideIntoWindow)("$_CONFIG", Object.assign({}, (0, $d08954e785180626$export$5ee78da69427eb2a), $9af22ef03b0ed505$var$productionConfig));


//# sourceMappingURL=index.6d4badff.js.map
